//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../Features/Features.FaceRecognitionBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"BlendFace",0,"ScCollector",0],[1,"FaceRecognized",0,"Features.FaceRecognitionBuilder",0],[1,"Radius",0,"Expression",0]],[[["blend_face"],"GetBlendFaceRadius",{R_:{radius:''}},1,0],[["inputFaces","numIsBlendFace","isBlendFace"],"IsBlendFace",{},1,0],[[],"ResizeBlendOnMultibodies",{},0,0]],[]];
SPLM.Features.ResizeBlendBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ResizeBlendBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;